document.addEventListener('DOMContentLoaded', () => {

  /**
   * Shopify hosted videos
   */
  document.querySelectorAll('.video-banner video').forEach(video => {

    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;

    // Hide controls if Shopify renders them
    video.controls = false;
    video.removeAttribute('controls');

    // Try autoplay
    const promise = video.play();

    if (promise !== undefined) {
      promise.catch(() => {
        // Ignore autoplay restrictions
      });
    }

  });


  /**
   * Resize YouTube/Vimeo iframe
   * to always cover the banner.
   */
  function resizeIframes() {

    document.querySelectorAll('.video-banner iframe').forEach(frame => {

      const wrapper = frame.closest('.video-banner__media');

      if (!wrapper) return;

      const w = wrapper.offsetWidth;
      const h = wrapper.offsetHeight;

      const ratio = 16 / 9;

      if (w / h > ratio) {

        frame.style.width = w + 'px';
        frame.style.height = (w / ratio) + 'px';

      } else {

        frame.style.height = h + 'px';
        frame.style.width = (h * ratio) + 'px';

      }

    });

  }

  resizeIframes();

  window.addEventListener('resize', resizeIframes);

});

window.addEventListener("load",function(){

document.querySelectorAll(".video-banner").forEach(function(section){

section.classList.add("loaded");

});

});